export default ({request}) => ({
  ecomAmzRecordSkuListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzRecordSku/list',
      method: 'POST',
      data,
    })
  },
})
